import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../_shared/shared.module';
import { NotFoundPageComponent } from './components/404/not-found-page.component';
import {
    ThemeModule,
    SupplyStackNotFoundPageModule,
    SupplyStackUnauthorizedPageModule,
} from '@slickss/supplystack-components';
import { supplystackTheme } from '@slickss/supplystack-components';
import { SupplyStackFormsHelperModule, SupplyStackNotificationsServiceModule } from '@slickss/supplystack-components';
import { SidebarSearchValueComponent } from './components/sidebar-search-value/sidebar-search-value.component';
import { CreditsModalComponent } from './components/credits/credits.component';
import { UnauthorizedPageComponent } from './components/403/unauthorized-page.component';
import { LandingPageComponent } from './components/landing-page/landing-page.component';
import { ServerDownPageComponent } from './components/502/server-down-page.component';
import { CookieBannerComponent } from './components/cookie-banner/cookie-banner.component';
import {MatDialogModule} from '@angular/material/dialog';

@NgModule({
    declarations: [
        NotFoundPageComponent,
        SidebarSearchValueComponent,
        CreditsModalComponent,
        UnauthorizedPageComponent,
        LandingPageComponent,
        ServerDownPageComponent,
        CookieBannerComponent,
    ],
    exports: [
        NotFoundPageComponent,
        SharedModule,
        ThemeModule,
        SupplyStackFormsHelperModule,
        SidebarSearchValueComponent,
        UnauthorizedPageComponent,
        LandingPageComponent,
        ServerDownPageComponent,
        CookieBannerComponent,
    ],
    imports: [
        ThemeModule.forRoot({
            themes: [supplystackTheme],
            active: 'SupplyStack',
        }),
        SupplyStackNotificationsServiceModule,
        SupplyStackFormsHelperModule,
        SupplyStackNotFoundPageModule,
        SupplyStackUnauthorizedPageModule,
        CommonModule,
        MatDialogModule,
        SharedModule,
    ],
    providers: []
})
export class CoreModule {}
